__turbopack_context__.v({
  "center": "ChipGroup-module-scss-module__6FaF_W__center",
  "chip": "ChipGroup-module-scss-module__6FaF_W__chip",
  "chipStack": "ChipGroup-module-scss-module__6FaF_W__chipStack",
  "dark": "ChipGroup-module-scss-module__6FaF_W__dark",
  "light": "ChipGroup-module-scss-module__6FaF_W__light",
  "right": "ChipGroup-module-scss-module__6FaF_W__right",
});
